exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SlideWithText1.s.scss","sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/components/contents/SlideWithText1/SlideWithText1.s.scss
// module id = 1148
// module chunks = 81